import React from "react";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(theme => (
    {
        backdrop: 
        {
            zIndex: theme.zIndex.drawer + 1000000000,
            color: '#fff',
        },
    })
);

class CSCOBackdrop  extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state =
        {
            mShow   : this.props.pShow
        }
    }

    componentDidMount()
    {
        this.setState({ mShow  : this.props.pShow })
    }

    componentDidUpdate(lPrevProps, lPrevState)
    {
        if(lPrevProps !== this.props)
        {
            if(lPrevProps.pShow !== this.props.pShow)
            {
                this.setState({ mShow  : this.props.pShow })
            }
        }
    }

    render()
	{
        return(
            <>
                <Backdrop className={useStyles.backdrop} style={{zIndex:'99'}} open={this.state.mShow}>
                    <CircularProgress color="primary" />
                </Backdrop>
            </>
        )
    }
}

export default CSCOBackdrop;
